export default {
  AllPartners: [],
  selectedPartnersForUpdate: {},
};
